import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { Avatar } from 'antd';
import classNames from 'classnames';

import GoBack from 'components/GoBackComponent';
import { Card } from 'components/AntD';
import { Check1 } from 'Icons';

export function StepWrapper({
  steps,
  currentStep,
  children,
  mainTitle = <Trans>Create a new role</Trans>,
  className = 'mw-640 m-auto',
}) {
  const selectedStep = steps.find((_step, index) => index === currentStep);
  const stepChildren = children.filter(node => !!node);
  return (
    <div className={classNames('step-wrapper tw-w-full', className)}>
      <div className="tw-flex tw-flex-row tw-gap-4 tw-justify-center tw-y-py-4 tw-border-b tw-border-gray-200">
        <h5 className="tw-my-3 tw-text-center tw-text-lg tw-font-semibold">{mainTitle}</h5>
      </div>
      <div className="tw-flex tw-justify-start tw-py-4 tw-gap-6">
        {steps.map((step, index) => (
          <div
            className="tw-flex tw-flex-row tw-gap-2 tw-items-center tw-justify-center tw-font-normal"
            key={step.label}
          >
            <Avatar
              size={24}
              className={classNames(
                'tw-font-semibold tw-text-xxs tw-flex tw-items-center tw-justify-center',
                {
                  'tw-bg-primary-200 tw-text-white': currentStep > index,
                  'tw-bg-primary tw-text-white': currentStep === index,
                  'tw-bg-gray-100 tw-text-gray-600': currentStep < index,
                }
              )}
            >
              {currentStep > index ? <Check1 color="white" width={12} height={12} /> : step.label}
            </Avatar>
            <div
              className={classNames('tw-text-xs', {
                'tw-text-primary': currentStep === index,
                'tw-text-gray-600': currentStep !== index,
              })}
            >
              {step.desc}
            </div>
          </div>
        ))}
      </div>
      {selectedStep && stepChildren[currentStep] && (
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div>
            <div className="tw-font-semibold tw-text-base">{steps[currentStep].title}</div>
            <span className="tw-text-sm tw-text-gray-700">{steps[currentStep].description}</span>
          </div>
          {stepChildren[currentStep]}
        </div>
      )}
    </div>
  );
}

StepWrapper.propTypes = {
  onBack: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  mainTitle: PropTypes.node,
  cardProps: PropTypes.object,
  children: PropTypes.node,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.number.isRequired,
      title: PropTypes.node.isRequired,
      description: PropTypes.node,
      desc: PropTypes.node.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export function SingleStep({ title, children }) {
  return (
    <div className="tw-container tw-max-w-7xl tw-py-sm sm:tw-py-reg xl:tw-mx-auto">
      <GoBack />
      <Card className="tw-container tw-max-w-2xl">
        {title && <div className="tw-font-semibold tw-text-lg">{title}</div>}
        {children}
      </Card>
    </div>
  );
}

SingleStep.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
};
